import React, { useMemo } from "react";
import PropTypes from "prop-types";

import ConfirmDialog from "dialogs/ConfirmDialog";

import useOtaHmacData from "hooks/packages/useOtaHmacData";

import DeleteIcon from "assets/svg/delete.svg";

import {
  UPDATE_OTA_HMAC,
  DELETE_OTA_HMAC,
  READ_OTA_HMAC_NAME,
} from "graphqlQueries/packages";

const DeleteOtaHmacDialog = (props) => {
  const { selected, name, onSuccessCallback, onClose } = props;
  const getHmacData = useOtaHmacData();
  const additionalProps = useMemo(() => {
    if (!selected.length)
      return {
        mutationQueries: DELETE_OTA_HMAC,
        title: "Delete HMAC file",
        subTitle: "The file will be deleted permanently.",
        initialValues: {},
      };
    const secrets = [];
    getHmacData().forEach((hmacInfo) => {
      if (selected.includes(hmacInfo.id)) return;
      secrets.push({
        aota_pkg_version: hmacInfo.aota_pkg_version,
        hmac_secret_b64url: hmacInfo.hmac_secret_b64url,
      });
    });
    const subTitle = name ? `for version ${name}` : `(${selected.length})`;
    return {
      mutationQueries: UPDATE_OTA_HMAC,
      title: "Delete HMAC",
      subTitle: `The hmac ${subTitle} will be deleted permanently.`,
      initialValues: { secrets },
    };
  }, [selected]);

  return (
    <ConfirmDialog
      refetchQueries={[READ_OTA_HMAC_NAME]}
      Icon={DeleteIcon}
      submitButtonName="Delete"
      onClose={onClose}
      variant="error"
      onSuccessCallback={onSuccessCallback}
      {...additionalProps}
    />
  );
};

DeleteOtaHmacDialog.propTypes = {
  selected: PropTypes.array,
  name: PropTypes.string,
  onSuccessCallback: PropTypes.func,
  onClose: PropTypes.func.isRequired,
};

export default DeleteOtaHmacDialog;
